// import React, { Component} from "react";
// import { Routes, Route, Navigate } from "react-router-dom";
// import "./sass/App.scss";
// import Dashboard from "./partials/Dashboard";
// import AppHeader from "./partials/AppHeader";
// import Title from "./partials/Title";
// import Menu from "./partials/Menu";
// import Login from "./partials/Login";
// import ForgotPassword from "./partials/ForgotPassword";
// import NewLocation from "./partials/NewLocation";
// import CustomiseData from "./partials/CustomiseData";
// import About from "./partials/About";
// import HowItWorks from "./partials/HowItWorks";
// import GetNotified from "./partials/GetNotified";
// // import TestMap from "./partials/TestMap";
// import GeoTiffDemo from "./GeoTiffDemo";
// import SearchLocation from "./partials/SearchLocation";
// import Terms from "./partials/Terms";
// import Privacy from "./partials/Privacy";
// import Footer from "./partials/Footer";

// var options = {
//   enableHighAccuracy: true,
//   timeout: 5000,
//   maximumAge: 0,
// };

// function errors(err) {
//   console.warn(`ERROR(${err.code}): ${err.message}`);
// }
// class App extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       locData: null,
//     };
//   }

//   componentDidMount() {
//     this.getData();
//   }

//   getData = () => {
//     fetch("/data/data.json")
//       .then((response) => response.json())
//       .then((json) =>
//         this.setState({
//           locData: json,
//         })
//       )
//       .catch((error) => {
//         console.log("fetch data failed", error);
//       });
//   };
  
//   render() {
//     const { locData } = this.state;
//     return (
//       <div className="App">
//         <AppHeader />

//         <div className="container">
//           <Routes>
//             <Route
//               path="/"
//               element={<Navigate to="/bengaluru/agriculture" replace />}
//             />

//             <Route path="/about" element={<About />} />
//             <Route path="/how-it-works" element={<HowItWorks />} />

//             {/* <Route path="/TestMap" element={<TestMap />} /> */}
//             <Route path="/searchLocation" element={<SearchLocation />} />
//             {/* <Route path="/pickLocation" element={<PickLocation />} /> */}
//             <Route path="/geo-tiff-demo" element={<GeoTiffDemo />} />

//             <Route
//               path="/:city/:domain"
//               element={locData && <Dashboard index locData={locData} />}
//             />

//             <Route path="/get-notified/:id" element={<GetNotified />} />
//             <Route path="login" element={<Login title={"Login"} />} />
//             <Route path="signup" element={<Login title={"Signup"} />} />
//             <Route path="forgot_password" element={<ForgotPassword />} />
//             <Route path="customise-data" element={<CustomiseData />} />
//             <Route path="new-location" element={<NewLocation />} />

//             <Route path="terms-and-conditions" element={<Terms />} />
//             <Route path="privacy-policy" element={<Privacy />} />
//           </Routes>

//           <Footer />
//         </div>
//       </div>
//     );
//   }
// }

// export default App;

import React, {  useContext, useEffect, useState} from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import "./sass/App.scss";
import Dashboard from "./partials/Dashboard";
import AppHeader from "./partials/AppHeader";
import Title from "./partials/Title";
import Menu from "./partials/Menu";
import Login from "./partials/Login";
import ForgotPassword from "./partials/ForgotPassword";
import NewLocation from "./partials/NewLocation";
import CustomiseData from "./partials/CustomiseData";
import About from "./partials/About";
import HowItWorks from "./partials/HowItWorks";
import GetNotified from "./partials/GetNotified";
// import TestMap from "./partials/TestMap";
import GeoTiffDemo from "./GeoTiffDemo";
import SearchLocation from "./partials/SearchLocation";
import Terms from "./partials/Terms";
import Privacy from "./partials/Privacy";
import Footer from "./partials/Footer";
import { CityContext } from "./partials/context/CityContext";
import { DomainContext } from "./partials/context/DomainNameContext";
import { NewAddDomain } from "./partials/context/NewAddDomain";
import ScrollToTop from "./partials/ScrollToTop";
import GeotiffLayer from "./components/GeoTiffLayer";
import { isMobile } from "react-device-detect";
import { ScrollToContext } from "./partials/context/ScrollToContext";
import Feedback from "./partials/Feedback";
import Legendcheck from "./partials/Legendcheck";
import { LoadingContext } from "./partials/context/Loading";
import { SelectedDataSet } from "./partials/context/SelectedDataset";
import { LayerContext } from "./partials/context/LayerContext";

const App = () => {
  const { city } = useContext(CityContext);
  const { domainUrl } = useContext(DomainContext);
  const [locData, setLocData] = useState(null);
  const { newAdd } = useContext(NewAddDomain);
  const { scrollId } = useContext(ScrollToContext);
  const {getScrollId}=useContext(ScrollToContext)
  const [show,setShow]=useState(false)
  const { getCity } = useContext(CityContext);
  const { getDomainName } = useContext(DomainContext);
  const { getLoading } = useContext(LoadingContext);
  const { getSelectedDataSet } = useContext(SelectedDataSet);
  const { getLayer } = useContext(LayerContext);
  const { getSelectedIdx } = useContext(SelectedDataSet);
  // const [url, setUrl] = useState();
  useEffect(() => {
    getData();
    // getCity("bengaluru");
  }, [])
  useEffect(() => {
    newAdd();
  }, [domainUrl])
  if (isMobile) {
    // console.log(window.scrollY)
  }
  useEffect(() => {
    if (window.scrollY == 0) {
      setShow(true);
    }
  },[])
  window.addEventListener("scroll", () => {
    if (window.scrollY>=0) {
      setShow(false);
    }
  })
  if (scrollId == true && isMobile) {
    const access = document.getElementById("scrollTo")
    access.scrollIntoView({ behavior: 'smooth' }, true);
    getScrollId(false);
  }
  // console.log(show);
  const getData = () => {
    fetch("/data/data.json")
      .then((response) => response.json())
      .then((json) => {
        // console.log("JSon",json);
        setLocData(json)
      }
      )
      .catch((error) => {
        console.log("fetch data failed", error);
      });
  };
  // console.log(locData);
  useEffect(() => {
    
  },[city])
  // console.log(domainUrl);
  const a = useLocation();
  let feedbackshow = true;
    // console.log(a.pathname);
    if (a.pathname.includes("agriculture") == true) {
      getDomainName("Agriculture")
    }
    else if (a.pathname.includes("risk") == true) {
      getDomainName("Risk")
    }
    else {
      getDomainName("Climate Change")
  }
  if (a.pathname.includes("customise-data") == true) {
    feedbackshow = false;
  }
  useEffect(() => {
    // console.log("zedxfcgtvyhuijokpojihugftcghijolkpkji")
      getSelectedDataSet();
      getLoading(true);
    getLayer(false);
    getSelectedIdx([]);
  },[a.pathname])
    // getDomainName(a.pathname);
  return (
    <div className="App">
      <ScrollToTop />
      {feedbackshow && <Feedback/>}
      
      <div id="scrollTo">
        <AppHeader />
      </div>
         
      {show == true && feedbackshow && isMobile && <div className="scrolldown">
        <span></span>
        <span></span>
        <span></span>
      </div>}
         <div className="container">
          <Routes>
             <Route
              path="/"
              element={<Navigate to={`/${city?city:"bengaluru"}/${domainUrl?domainUrl:"agriculture"}`} replace />}
            />
            <Route path="/about" element={<About />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            {/* <Route path="/legend" element={<Legendcheck/>} /> */}
            {/* <Route path="/TestMap" element={<TestMap />} /> */}
            <Route path="/searchLocation" element={<SearchLocation />} />
            {/* <Route path="/pickLocation" element={<PickLocation />} /> */}
            <Route path="/geo-tiff-demo" element={<GeoTiffDemo locData={locData} />} />

            <Route
              path="/:city/:domain"
              element={locData && <Dashboard index locData={locData} />}
            />

            <Route path="/get-notified/:id" element={<GetNotified />} />
            <Route path="login" element={<Login title={"Login"} />} />
            <Route path="signup" element={<Login title={"Signup"} />} />
            <Route path="forgot_password" element={<ForgotPassword />} />
            <Route path="customise-data" element={<CustomiseData />} />
            <Route path="new-location" element={<NewLocation />} />

            <Route path="terms-and-conditions" element={<Terms />} />
          <Route path="privacy-policy" element={<Privacy />} />
          <Route path="/layer" element={<GeotiffLayer/>}/>
          </Routes>

          <Footer />
        </div>
      </div>
  )
}

export default App